angular.module('impactx.cancelcondition').controller('CancelConditionDetailController', CancelConditionDetailController);
CancelConditionDetailController.$inject = [
    '$scope',
    'dataGen',
    'BackService',
    '$mdToast',
    'ConfirmationService',
    '$routeParams',
    'OutsourcedCommentSaveService',
    'ToolbarService'
];

function CancelConditionDetailController($scope, dataGen, BackService, $mdToast, ConfirmationService, $routeParams, OutsourcedCommentSaveService, ToolbarService) {
    var ctrl = this;

    dataGen.getData($scope, {id: $routeParams.id}, "/cancelcondition/view").then(function () {
        defineButtons();
    });

    $scope.closeFunction = function () {
        BackService.back();
        $mdToast.show(
            $mdToast.simple()
                .textContent($scope.trns.saveSuccess)
                .position("bottom right")
                .hideDelay(10000)
        );
    };


    this.save = function () {
        var extractedComments = OutsourcedCommentSaveService.extractComments($scope.data);

        var dataObj = {
            data: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/cancelcondition/save").then(function (commentData) {
            if (commentData && commentData.data) {
                OutsourcedCommentSaveService.saveComments(commentData.data, extractedComments).then($scope.closeFunction);
            }
            else {
                $scope.closeFunction();
            }
        }, function () {
            OutsourcedCommentSaveService.restoreComments($scope.data, extractedComments);
        });
    };

    this.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    this.delete = function () {
        var dataObj = {
            id: $scope.data.id
        };
        dataGen.getData($scope, dataObj, "/cancelcondition/delete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.deleteSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.deleteDialog,
                type: 'dialogaction',
                condition: isEditable
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }
}